import React from 'react'

const EtAdminHeatmaps = () => {
  return (
    <div>EtAdminHeatmaps</div>
  )
}

export default EtAdminHeatmaps